// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/a" + chunkId + "-" + {"780":"666c6d4","838":"87840ff"}[chunkId] + ".js";
};